import { getApiErrorText } from './apiResponse';

export const getPromoErrorText = error => {
  const fallback = 'Не вдалося перевірити промокод. Спробуйте ще раз.';
  const message = getApiErrorText(error, fallback);
  if (error?.response?.status >= 500 || (error?.request && !error?.response)
      || /Виникла непередбачувана проблема|Request failed with status code|Network Error|timeout of \d+ms exceeded/i.test(message)) return fallback;
  if (['Промокод не знайдено', 'Такого промокоду немає'].includes(message)) {
    return 'Промокод не знайдено або він неактивний. Перевірте правильність введення і спробуйте ще раз.';
  }
  return message;
};

